<h1 class="c-heading u-mtop-mobile-md">Log in failed</h1>
<p class="c-text-width">Your log on attempt has failed. Please enter your email address associated to your Minster Law Online account to reset your password.</p>
<div class="u-mtop-ism">
    <minster-link id="ResetPasswordLink" [mlRouterLink]="['../forgotten-password']" text="Reset your password?"></minster-link>
</div>
